import { Box, Divider, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { USER_GENDER_LABEL_MAPPER } from '../../../../data';
import { useStoreContext } from '../../../../hooks/useStore';
import { FlagIcon } from '../../../FlagIcon';
import { DeleteProfile } from '../DeleteProfile';
import { ProfileDataRow } from '../ProfileDataRow';
import { EditDataBtn } from '../../../Buttons/EditDataBtn';
import { ProfileResetPassword } from '../ProfileResetPassword';

export const ProfileTabPreview = ({ onChangeTab }: { onChangeTab: (x: number) => void }) => {
  const { t } = useTranslation();
  const {
    store: { user },
  } = useStoreContext();

  return (
    <>
      <VStack my={6} spacing={4} alignItems='flex-start'>
        <ProfileDataRow label={`${t('input.email.label')}`} message={user?.email} />
        <ProfileDataRow label={`${t('input.postal.code.label')}`} message={user?.postalCode} />
        <ProfileDataRow
          label={`${t('input.mobile.phone.label')}`}
          message={user?.mobilePhone}
          leftEl={
            <FlagIcon
              phone={user?.mobilePhone}
              style={{ minWidth: '13px', minHeight: '13px', marginRight: '.5em', top: '.05em' }}
            />
          }
        />
        <ProfileDataRow
          label={`${t('input.gender.label')}`}
          message={`${user?.gender ? t(USER_GENDER_LABEL_MAPPER[user.gender]) : ''}`}
        />
        <EditDataBtn onClick={() => onChangeTab(1)}>{t('profile.edit.btn')}</EditDataBtn>
      </VStack>

      <Divider />

      <Box mt={6}>
        <ProfileResetPassword />
      </Box>

      <Box mt={6}>
        <DeleteProfile />
      </Box>
    </>
  );
};
